export const FETCH_AGENCIES_REQUEST = 'FETCH_AGENCIES_REQUEST';
export const FETCH_AGENCIES_SUCCESS = 'FETCH_AGENCIES_SUCCESS';
export const FETCH_AGENCIES_FAILURE = 'FETCH_AGENCIES_FAILURE';

export const FETCH_AGENCIES_RELEASE_REQUEST = 'FETCH_AGENCIES_RELEASE_REQUEST';
export const FETCH_AGENCIES_RELEASE_SUCCESS = 'FETCH_AGENCIES_RELEASE_SUCCESS';
export const FETCH_AGENCIES_RELEASE_FAILURE = 'FETCH_AGENCIES_RELEASE_FAILURE';

export const FETCH_AGENCY_REQUEST = 'FETCH_AGENCY_REQUEST';
export const FETCH_AGENCY_SUCCESS = 'FETCH_AGENCY_SUCCESS';
export const FETCH_AGENCY_FAILURE = 'FETCH_AGENCY_FAILURE';

export const UPDATE_AGENCIES_REQUEST = 'UPDATE_AGENCIES_REQUEST';
export const UPDATE_AGENCIES_SUCCESS = 'UPDATE_AGENCIES_SUCCESS';
export const UPDATE_AGENCIES_FAILURE = 'UPDATE_AGENCIES_FAILURE';

export const DELETE_AGENCIES_REQUEST = 'DELETE_AGENCIES_REQUEST';
export const DELETE_AGENCIES_SUCCESS = 'DELETE_AGENCIES_SUCCESS';
export const DELETE_AGENCIES_FAILURE = 'DELETE_AGENCIES_FAILURE';

export const OPEN_EDIT_PAGE_AGENCY = 'OPEN_EDIT_PAGE_AGENCY';
export const OPEN_EDIT_PAGE_AGENCY_SUCCESS = 'OPEN_EDIT_PAGE_AGENCY_SUCCESS';

export const CLEAR_AGENCY_ERRORS = 'CLEAR_AGENCY_ERRORS';
export const CLEAR_AGENCY_SUCCESS = 'CLEAR_AGENCY_SUCCESS';